// Libs
import React from 'react'

// Components
import Spinner from 'react-spinkit'

// Styles
import { white } from 'hfty-styles/src/colors'

const componentStyle = {
  padding: 7,
  backgroundColor: white(),
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}

// Exports
export default function SearchIndicator () {
  return (
    <div style={componentStyle}>
      <Spinner />
    </div>
  )
}
